// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ni+GA","input-checkbox":"styles_input-checkbox__ic-vM","label":"styles_label__W576C"};